/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface StoreInfoDto { 
    cdStore?: number;
    dsName?: string;
    dsStoreTypeName?: string;
    qtStars?: number;
    dsAddress?: string;
    dsPhone?: string;
    dtOpeningTime?: Date;
    dtClosingTime?: Date;
    qtPersonCost?: number;
    nmDeliveryTime?: number;
}